const briefSectionPaths = {
  listBoard: 'board/:id',
  files: 'files/:id/:fileId?',
  order: 'order/:id',
  presentation: 'presentation/:id/:slideId?',
  whiteboard: 'whiteboards/:id',
  workflow: 'workflows/:id',
  section: 'sections/:id',
  map: 'maps/:id',
};

const briefPaths = {
  dashboard: 'dashboard',
  settings: 'settings',
  csvUpsert: 'csv-upsert',
  pendingCards: 'pending-cards',
  cards: 'cards',
  briefHome: 'home',
  coaBrief: 'coa-brief',
  afterActionReport: 'after-action-report',
  afterActionReportByRun: 'after-action-report/:runId',
  coaAnalysis: 'coa-analysis',
  coaAarHistory: 'coa-analysis/:coaDocumentId/aars',
  wargameDashboard: 'wargame-dashboard',
  newArtifact: 'new-artifact',
  ...briefSectionPaths,
} as const;

const paths = {
  ...briefPaths,
  briefRoot: '/:owner/:briefKey/*',
  presenterView: '/:owner/:briefKey/presentation/:id/presenter-view/:slideId?',
  iFramePresentation: '/embeds/:embedId/:id/:slideNumber/:briefId/:token',
  orgGuest: '/home/organizations/:idString/guest',
  org: '/home/organizations/:idString',
  admin: '/admin',
  login: '/login',
  logout: '/logout',
  reset: '/reset',
  signup: '/signup',
  terms: '/terms',
  privacy: '/privacy',
  consent: '/consent',
  verifyEmail: '/verify-email',
  accountStatus: '/account-status',
  loginExpired: '/login/expired',
  loggedOut: '/logged-out',
  newBrief: '/new',
  homePlans: '/home/plans',
  home: '/',
} as const;

const pathValues = Object.values(paths);

// Fully-qualified patterns for telemetry matching.
// Relative brief paths get the briefRoot prefix; absolute paths stay as-is.
const briefPrefix = paths.briefRoot.replace('*', '');
const telemetryPathValues = Object.entries(paths)
  .filter(([key]) => key !== 'briefRoot')
  .map(([, p]) => (p.startsWith('/') ? p : `${briefPrefix}${p}`));

// Section name segments derived from briefSectionPaths (e.g. 'board', 'files', 'maps').
const briefSectionTypes = new Set(
  Object.values(briefSectionPaths)
    .map((path) => path.split('/')[0])
    .filter((segment): segment is string => !!segment && !segment.startsWith(':'))
);

// All known brief page segments (sections + non-section pages like dashboard, settings, etc.)
const briefPageTypes = new Set([
  ...briefSectionTypes,
  ...Object.values(briefPaths)
    .map((path) => path.split('/')[0])
    .filter((segment): segment is string => !!segment && !segment.startsWith(':')),
]);

export { paths, pathValues, telemetryPathValues, briefSectionTypes, briefPageTypes };
